import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';
import Image from '@eliadmin/core/src/components/image/image-wrapped';

import type { IconsWithTextType } from '@eliadmin/core/src/api/general/types/general-types';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { HtmlRendererRaw } from '@eliadmin/core/src/components/ui/html-renderer-raw';

export function ServiceIconCard({ icon }: { icon: IconsWithTextType }) {
  return (
    <div
      className={cn(
        'col-span-1 flex w-full flex-col items-start justify-start gap-8 bg-white p-4 sm:p-5 md:flex-row md:gap-4 lg:gap-6 lg:p-6 xl:gap-8',
        'ea-service-icon-card',
      )}
    >
      <div className="flex max-h-12 min-h-12 min-w-12 max-w-12 items-center justify-center bg-primary sm:max-h-14 sm:min-h-14 sm:min-w-14 sm:max-w-14 lg:max-h-16 lg:min-h-16 lg:min-w-16 lg:max-w-16">
        <Image
          src={icon?.image?.url ?? '/images/placeholder.png'}
          alt={icon.name?.trim() ? '' : resolveImageAlt(icon?.image, undefined)}
          width={0}
          height={0}
          className="h-[27px] w-[27px] object-contain sm:h-8 sm:w-8 lg:h-9 lg:w-9"
        />
      </div>
      <div className="flex w-full flex-col items-start justify-start gap-1">
        <h3 data-ea-visual-tag="h5" className="text-lg font-bold text-black lg:text-xl xl:text-2xl">{icon.name}</h3>
        <HtmlRendererRaw
          className={cn('w-full', 'ea-service-icon-card__description')}
          html={icon.description ?? ''}
        />
      </div>
    </div>
  );
}
